import styled from 'styled-components'

export const Layout = styled.div`
  position: relative;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: end;
`

export const Description = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 1rem;
  color: ${props => props.theme.colors.color545e6c};
  white-space: break-spaces;
`

export const ChanceText = styled.p`
  font-family: 'Inter';
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: ${props => props.theme.colors.color545e6c};
`
